<template>
  <div class="w-100">
    <div class="amount-distribution-container w-100">
      <div class="amount-items-row">
        <!--les montant-->
        <div class="amount-item">
          <a-form-item label="Montant espèce" class="mb-1">
            <a-input-number
              style="width: 100%"
              :disabled="true"
              :precision="3"
              :min="0"
              v-decorator="[
                'montantEspece',
                {
                  initialValue: 0,
                },
              ]"
            />
          </a-form-item>
        </div>
        <div class="amount-item">
          <a-form-item label="Montant chèque:" class="mb-1">
            <a-input-number
              style="width: 100%"
              :disabled="true"
              :precision="3"
              v-decorator="[
                'montantCheque',
                {
                  initialValue: 0,
                },
              ]"
            />
          </a-form-item>
        </div>

        <div class="amount-item">
          <a-form-item label="Montant TPE:" class="mb-1">
            <a-input-number
              style="width: 100%"
              :disabled="true"
              :precision="3"
              v-decorator="[
                'montantTPE',
                {
                  initialValue: 0,
                },
              ]"
            />
          </a-form-item>
        </div>
        <div class="amount-item">
          <a-form-item label="Montant traite:" class="mb-1">
            <a-input-number
              style="width: 100%"
              :disabled="true"
              :precision="3"
              v-decorator="[
                'montantTraite',
                {
                  initialValue: 0,
                },
              ]"
            />
          </a-form-item>
        </div>
        <div class="amount-item">
          <a-form-item label="Montant virement:" class="mb-1">
            <a-input-number
              style="width: 100%"
              :disabled="true"
              :precision="3"
              v-decorator="[
                'montantVirement',
                {
                  initialValue: 0,
                },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <a-alert
        v-if="disabled"
        :message="`Les informations sur les montants sont incorrectes, veuillez les corriger avant de distribuer les montants. Le montant total doit être : ${
          WithAvance ? avanceAmount.toFixed(3) : total.aReduction.toFixed(3)
        }`"
        type="error"
        banner
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ChequeCashDistribution",

  props: {
    total: {
      required: true,
      type: Object,
    },
    disabled: {
      required: true,
      type: Boolean,
    },
    form: {
      required: true,
      type: Object,
    },
    WithAvance: {
      required: true,
      type: Boolean,
    },
    avanceAmount: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style scoped>
.amount-distribution-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 12px;
}

.amount-items-row {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

.amount-item {
  flex: 1;
  width: calc(20% - 12.8px); /* 5 items with gap consideration */
  display: flex;
  flex-direction: column;
}

.amount-item .ant-form-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 0;
}

.amount-item .ant-form-item-label {
  flex: 0 0 auto;
  margin-bottom: 4px;
  text-align: left;
}

.amount-item .ant-form-item-control {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.amount-item .ant-input-number {
  flex: 1;
  width: 100%;
}

.error-message {
  width: 100%;
  margin-top: 0;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .amount-items-row {
    flex-direction: column;
    gap: 12px;
  }

  .amount-item {
    width: 100%;
  }
}
</style>
